<template>
  <div>
    <div class="z-20 w-full fixed top-0">
      <MerchantNav :empty-middle="true" :category-count="categories.length" :show-cart-pill="false" />
      <V2MerchantCategoriesBar
        :categories="categories"
        :v2-cart-quantity="0"
        :v2-cart-total="null"
        :v2-show-prices="true"
      />
    </div>
    <p v-if="failed" class="fixed bottom-4 inset-x-4 z-30 rounded-md bg-red-50 p-3 text-center text-sm text-red-700">
      We couldn't start your order. Please try again.
    </p>
    <V2Store
      :store="menu.store"
      :local-cart-items="localCartItems"
      :server-cart-items="[]"
      :in-cart="false"
      :bottle-status-props="bottleStatusProps"
      :unavailable-cart-items="[]"
    />
    <div v-if="openForOrders && siblingStores.length > 0" class="pb-8">
      <V2StoreListCarousel :sibling-stores="siblingStores" />
    </div>
    <V2ProductModalHost
      v-if="hasCartModals"
      ref="productModalHost"
      :store="menu.store"
      :local-cart-items="localCartItems"
      :cart-settled="true"
    />
  </div>
</template>

<script>
import { computed, onMounted, provide, ref } from 'vue'
import { MerchantNav } from '@/components'
import V2Store from '@/components/v2/V2Store'
import V2StoreListCarousel from '@/components/v2/V2StoreListCarousel'
import V2MerchantCategoriesBar from '@/components/v2/V2MerchantCategoriesBar'
import V2ProductModalHost from '@/components/v2/V2ProductModalHost'
import { useStartCart } from '@/composables/useBrowseMenu'
import loadV2Selection from '@/utils/loadV2Selection'

export default {
  components: { MerchantNav, V2Store, V2StoreListCarousel, V2MerchantCategoriesBar, V2ProductModalHost },

  props: {
    storeId: { type: [String, Number], required: true },
    menu: { type: Object, required: true }
  },

  setup(props) {
    const { starting, failed, items, startCart } = useStartCart(
      () => props.storeId,
      () => props.menu
    )
    const startingTierId = computed(() => props.menu.store?.default_membership_tier_id ?? null)

    provide('v2UpdateCartItem', startCart)
    provide('v2IsSubmittingCart', starting)
    provide(
      'v2OpenForOrders',
      computed(() => props.menu.status_for_placing_orders?.status === 'open')
    )
    provide('v2DefaultMembershipTierId', startingTierId)
    provide('v2CustomerMembershipTierId', startingTierId)

    const productModalHost = ref(null)
    provide('v2OpenProductModal', (payload) => productModalHost.value?.open(payload))

    onMounted(() => loadV2Selection().catch(() => null))

    return { localCartItems: items, failed, productModalHost }
  },

  computed: {
    categories() {
      return (this.menu.store?.categories || []).filter((c) => c.type !== 'UpsellCategory')
    },
    openForOrders() {
      return this.menu.status_for_placing_orders?.status === 'open'
    },
    siblingStores() {
      return this.menu.store?.sibling_stores || []
    },
    hasCartModals() {
      return this.$store.getters.hasCartModals
    },
    bottleStatusProps() {
      if (this.openForOrders) return null
      return {
        arrivalDate: null,
        cutoff: null,
        expired: false,
        autocharge: false,
        autochargeDatetime: null,
        confirmed: false,
        blockSkip: false,
        openForOrders: false,
        nextSlotOpens: this.menu.status_for_placing_orders?.next_slot_opens || null,
        cartIsEmpty: true
      }
    }
  }
}
</script>
